import { ElementTypes } from '../element-types';

export class Details {
  private static readonly prefix: string = 'details';
  static readonly DependentInfo: string = `${Details.prefix}-${ElementTypes.Div}-dependent-info`;

  static readonly AddressInfo: string = `${Details.prefix}-${ElementTypes.Div}-address-info`;
  static readonly AddressLineOne: string = `${Details.prefix}-${ElementTypes.Input}-address-line-1`;
  static readonly AddressLineTwo: string = `${Details.prefix}-${ElementTypes.Input}-address-line-2`;
  static readonly AddressPostTown: string = `${Details.prefix}-${ElementTypes.Input}-post-town`;
  static readonly AddressCounty: string = `${Details.prefix}-${ElementTypes.Input}-county`;
  static readonly AddressPostcode: string = `${Details.prefix}-${ElementTypes.Input}-postcode`;
  static readonly PmiOption: string = `${Details.prefix}-${ElementTypes.Div}-pmi-option`;
  static readonly MembershipNumber: string = `${Details.prefix}-${ElementTypes.Input}-membership`;
  static readonly TermAndConditionBase: string = `${Details.prefix}-${ElementTypes.Div}-term-condition`;
  static readonly TermAndConditionInfo: string = `${Details.TermAndConditionBase}-info`;
  static readonly TermAndConditionOption: string = `${Details.TermAndConditionBase}-option`;
  static readonly Province: string = `${Details.prefix}-${ElementTypes.Input}-province`;

  static readonly ProceedToPayment: string = `${Details.prefix}-${ElementTypes.Button}-proceed-to-payment`;
  static readonly MainContent: string = `${Details.prefix}-${ElementTypes.Div}-main-content`;

  static FirstName(index: number): string {
    return `${Details.prefix}-${ElementTypes.Input}-first-name-${index}`;
  }
  static LastName(index: number): string {
    return `${Details.prefix}-${ElementTypes.Input}-last-name-${index}`;
  }
  static Email(index: number): string {
    return `${Details.prefix}-${ElementTypes.Input}-email-${index}`;
  }
  static Phone(index: number): string {
    return `${Details.prefix}-${ElementTypes.Input}-phone-${index}`;
  }
  static Birthday(index: number): string {
    return `${Details.prefix}-${ElementTypes.Input}-dob-${index}`;
  }
  static CheckTermAndCondition(index: number): string {
    return `${Details.TermAndConditionBase}-${index}`;
  }

  static TravellerDetails(isDependent: boolean, index: number): string {
    const infoSegment = isDependent ? 'dependent-info' : 'traveller-info';
    return `${Details.prefix}-${ElementTypes.Host}-${infoSegment}-${index}`;
  }
}
